import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import TimerOutlinedIcon from "@mui/icons-material/TimerOutlined";
import TimestampCommentField from "./TimestampCommentField";

export default function CommentEditForm({
    value,
    onChange,
    onCancel,
    onSave,
    onAddTimestamp,
    onTimestampClick,
    isSaving = false,
}) {
    const canSave = value.trim() !== "" && !isSaving;

    return (
        <Box
            sx={{
                width: "100%",
                mt: 0.75,
                p: 1.25,
                borderRadius: 2,
                border: "1px solid",
                borderColor: "rgba(0, 149, 61, 0.22)",
                backgroundColor: "#f7f9f7",
            }}
        >
            <TimestampCommentField
                autoFocus
                label="Edit comment"
                value={value}
                disabled={isSaving}
                onChange={onChange}
                onCancel={onCancel}
                onSubmit={canSave ? onSave : undefined}
                onTimestampClick={onTimestampClick}
            />
            <Box
                sx={{
                    display: "flex",
                    flexDirection: { xs: "column", sm: "row" },
                    alignItems: { xs: "stretch", sm: "center" },
                    justifyContent: "space-between",
                    gap: 1,
                    mt: 1,
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1.25,
                    }}
                >
                    {onAddTimestamp && (
                        <Button
                            size="small"
                            startIcon={<TimerOutlinedIcon />}
                            onClick={onAddTimestamp}
                            disabled={isSaving}
                        >
                            Add timestamp
                        </Button>
                    )}
                </Box>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: 0.75,
                    }}
                >
                    <Button
                        size="small"
                        color="inherit"
                        onClick={onCancel}
                        disabled={isSaving}
                    >
                        Cancel
                    </Button>
                    <Button
                        size="small"
                        variant="contained"
                        disableElevation
                        startIcon={<SaveOutlinedIcon />}
                        onClick={onSave}
                        disabled={!canSave}
                    >
                        {isSaving ? "Saving…" : "Save"}
                    </Button>
                </Box>
            </Box>
        </Box>
    );
}
